var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-screen",attrs:{"id":"app"}},[_c('HFooter'),(_vm.isLogin)?_c('Navbar'):_vm._e(),_c('div',{staticClass:"flex-grow py-4"},[_c('router-view')],1),(_vm.isLogin)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }